// extracted by mini-css-extract-plugin
export default {"iconsContainer":"SchoolRoutes_iconsContainer__QKSIi","iconContainer":"SchoolRoutes_iconContainer__cIEXz","iconImg":"SchoolRoutes_iconImg__HvX5d"};